/**
 * Package-level metadata for the package configurator ("Основна" tab). Pricing is NOT here — it
 * lives on each `PackageContent` (see `package.model.ts`), because every content version carries its
 * own price. B2C-only fields (packageType, clientType, dates) are omitted for the B2B-only flow.
 */

export interface PackageGeneralInfo {
  name: string;
  /** Internal name (shown to internal staff, e.g. in the HM portal). */
  internalName: string;
  /** User-facing description. */
  description: string;
  /** Internal-only description (not shown to clients; surfaced in the HM portal). */
  internalDescription: string;
  /** URL to the full package description document, surfaced to the member (e.g. in the mobile app profile). */
  packageDescriptionUrl: string;
}

export function buildDefaultGeneralInfo(): PackageGeneralInfo {
  return { name: '', internalName: '', description: '', internalDescription: '', packageDescriptionUrl: '' };
}
